import { useRemoteClientGet, useRemoteClientPut } from '@/configs/http-client'
import { Form, FormControl, FormField, FormItem, FormLabel, FormMessage } from '@/view/components/ui/form'
import { Input } from '@/view/components/ui/input'
import { useToast } from '@/view/hooks'
import { formatDateString } from '@/view/utils/formatDate'
import { CatchMessageError } from '../../../remote/catch-message-error'
import { Contrato, contratoSchema } from '@/view/validators/contract-study'
import { zodResolver } from '@hookform/resolvers/zod'
import { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useSearchParams } from 'react-router-dom'
import { useHookFormMask } from 'use-mask-input'
import { convertParamsToJson, useCashfitParams } from '@/view/hooks/use-params'
import { Button } from '@/view/components/ui/button'
import { convertDateDisplayFormat } from '@/view/utils/formatDateDisplay'





export default function ContractForm({ idPlano, idAluno }: { idPlano: number | string | undefined | null, idAluno: number | string | undefined | null }) {
  const { remoteClientGet } = useRemoteClientGet()
  const [loading, setLoading] = useState(false)
  const { httpClientPut } = useRemoteClientPut()
  const [data, setData] = useState<any>({})
  const { showToast } = useToast()
  const [params] = useSearchParams()
  const { setParams } = useCashfitParams(convertParamsToJson(params))

  const form = useForm<Contrato>({
    resolver: zodResolver(contratoSchema),
    defaultValues: {
      dataInicio: '',
      dataVencimento: '',
      //dataVencimento: convertDateDisplayFormat(data?.dataVencimento?.split('T')[0] || '')

    }
  })

  const {
    formState: { errors }
  } = form

  useEffect(() => {
    console.log('Erros do formulário:', errors)
  }, [errors])


  useEffect(() => {
    if (idPlano && idAluno && !loading) {
      setLoading(true)
      remoteClientGet(`/vendas/contratos/aluno/${idAluno}/plano/${idPlano}`)
        .then((response) => {
          console.log('Debug')
          console.log(response.data.data)

          setData(response.data.data)
          form.setValue('nome', response.data.data?.nomeContrato)
          form.setValue('dataInicio', convertDateDisplayFormat(response.data.data?.dataInicio.split('T')[0] || ''))
          form.setValue('dataVencimento', convertDateDisplayFormat(response.data.data?.dataVencimento.split('T')[0] || ''))
          form.setValue('id', response.data.data?.idContrato)
        })
        .catch(CatchMessageError)
        .finally(() => setLoading(false))
    }
  }, [idPlano, idAluno])

  //const backToStudents = () => setParams({ tabSelected: 'studants' as any })

  const onSubmit = async (formData: any) => {


    setParams({ tabPlanId: '' as any })
    const formattedData = {
      ...formData,
      dataInicio: formatDateString(formData.dataInicio),
      dataVencimento: formatDateString(formData.dataVencimento),
    }

    try {

      await httpClientPut('/contratos-venda', { id: data.id, ...formattedData })


      showToast('Contrato salvo com sucesso', 'success')
      form.reset()
    } catch (error: any) {
      console.error('Erro no envio:', error?.response?.data?.errors)
      const errors = error?.response?.data?.errors
      if (errors) {
        for (const key in errors) {
          showToast(errors[key], 'error')
        }
      } else {
        showToast('Erro ao enviar requisição', 'error')
      }
    }
  }

  const registerWithMask = useHookFormMask(form.register)

  return (
    <Form {...form}>
      <form
        id="formContract"
        onSubmit={form.handleSubmit(onSubmit)}
        className="flex flex-col gap-6 p-4 max-w-3xl mx-auto"
      >
        <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
          <FormField
            control={form.control}
            name="nome"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  <span className="text-red-500">*</span> Nome
                </FormLabel>
                <FormControl>
                  <Input {...field} placeholder="Nome do contrato" disabled />
                </FormControl>
                <FormMessage className="text-sm text-red-500" />
              </FormItem>
            )}
          />
  
          <FormField
            control={form.control}
            name="dataInicio"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  <span className="text-red-500">*</span> Data de Início
                </FormLabel>
                <FormControl>
                  <Input
                    {...field}
                    {...registerWithMask('dataInicio', '99/99/9999')}
                    placeholder="dd/mm/yyyy"
                  />
                </FormControl>
                <FormMessage className="text-sm text-red-500" />
              </FormItem>
            )}
          />
  
          <FormField
            control={form.control}
            name="dataVencimento"
            render={({ field }) => (
              <FormItem>
                <FormLabel>
                  <span className="text-red-500">*</span> Data de Vencimento
                </FormLabel>
                <FormControl>
                  <Input
                    {...field}
                    {...registerWithMask('dataVencimento', '99/99/9999')}
                    placeholder="dd/mm/yyyy"
                  />
                </FormControl>
                <FormMessage className="text-sm text-red-500" />
              </FormItem>
            )}
          />
        </div>
  
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 text-sm text-muted-foreground bg-acelerafit-gray-white p-4 rounded-lg shadow-sm">
          <div>
            <span className="font-semibold">Nome do Plano:</span> {data?.nomePlano}
          </div>
          <div>
            <span className="font-semibold">Valor do Plano:</span> {data?.valorPlano}
          </div>
          <div>
            <span className="font-semibold">Nome do Aluno:</span> {data?.nomeAluno}
          </div>
        </div>
  
        <div className="flex flex-col sm:flex-row justify-end gap-3 mt-6">
          <Button
            type="button"
            onClick={() => setParams({ tabPlanId: '' })}
            className="w-full sm:w-auto bg-acelerafit-green-50 text-white font-bold hover:bg-acelerafit-green-100"
          >
            Voltar
          </Button>
          <Button
            type="submit"
            className="w-full sm:w-auto bg-acelerafit-green-300 text-white font-bold hover:bg-acelerafit-green-400"
          >
            Atualizar
          </Button>
        </div>
      </form>
    </Form>
  );
}